import casinoConfig from '@dcentralexpedientedigital/config';
import { SpinnerImage } from '@dcentralexpedientedigital/fe-ui/components/shared/components/loader/spinner-image/spinner-image';

export const AuthRedirectSpinner = () => (
    <SpinnerImage imageUrl={casinoConfig.themes.light.logos.compact} className="mt-5" />
);
